<template>
	<div class="cf">
		<div class="cf__elm">
			<!-- //////////////// -->
			<!-- Введите код подтверждения -->
			<div class="cf__elm-label">
				Для номера {{ formatPhoneNumber(phoneNumber.phone) }} отправлен
				код.
			</div>
			<div class="cf__elm-label">Введите код подтверждения</div>
			<div class="cf__elm-code">
				<div class="cf__elm-code-input">
					<input
						id="1"
						ref="d1"
						@keyup="onDigit"
						@keyup.enter="onClickCheckCode"
						type="number"
						class="cf__elm-code-input-num"
					/>
				</div>

				<div class="cf__elm-code-input">
					<input
						id="2"
						ref="d2"
						@keyup="onDigit"
						@keyup.enter="onClickCheckCode"
						type="number"
						class="cf__elm-code-input-num"
					/>
				</div>

				<div class="cf__elm-code-input">
					<input
						id="3"
						ref="d3"
						@keyup="onDigit"
						@keyup.enter="onClickCheckCode"
						type="number"
						class="cf__elm-code-input-num"
					/>
				</div>

				<div class="cf__elm-code-input">
					<input
						id="4"
						ref="d4"
						@keyup="onDigit"
						@keyup.enter="onClickCheckCode"
						type="number"
						class="cf__elm-code-input-num"
					/>
				</div>

				<div class="cf__elm-code-input">
					<input
						id="5"
						ref="d5"
						@keyup="onDigit"
						@keyup.enter="onClickCheckCode"
						type="number"
						class="cf__elm-code-input-num"
					/>
				</div>
			</div>

			<!-- //////////////// -->
			<!-- Кнопка отправить -->

			<UiButton
				class="cf__elm-btn"
				@click="onClickCheckCode"
				label="Отправить"
				:background-color="
					isButtonDisable
						? 'rgb(244, 246, 250)'
						: `var(--theme-color)`
				"
				:border-color="
					isButtonDisable
						? 'rgb(244, 246, 250)'
						: `var(--theme-color)`
				"
				color="rgb(255, 255, 255)"
				font-weight="600"
				font-size="16px"
			/>

			<!-- //////////////// -->
			<!-- Повторно отправить код -->
			<div
				v-if="isExpired"
				class="cf__elm-send-code"
				@click="resendConfirmCode"
			>
				Повторно отправить код
			</div>

			<!-- Уведомление об ошибке -->
			<div
				v-if="attemptsCount !== 0 && attemptsCount < 3"
				class="cf__elm-error"
			>
				Неверно введен проверочный код. Осталось
				{{ 3 - attemptsCount }} попытки.
			</div>

			<div v-if="attemptsCount > 2" class="cf__elm-error">
				В течение 5 мин. Ваш номер телефона заблокирован.
			</div>

			<div v-if="isExpired" class="cf__elm-error">
				Проверочный код недействителен
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import UiButton from "@/components/ui/UiButton.vue";
import { mapActions, mapGetters } from "vuex";

@Options({
	components: { UiButton },

	computed: {
		...mapGetters("registrationModule", {
			confirmation: "confirmationCodeGetters",
			increaseAttempts: "increaseAttemptsGetters",
			phoneNumber: "phoneNumberGetters",
		}),
	},

	methods: {
		...mapActions("registrationModule", [
			"checkConfirmationCodeAction",
			"increaseAttemptsAction",
			"registrationAction",
		]),
		...mapActions("authModule", [
			"checkAuthAction",
			"loginGenerateConfirmationCodeAction",
		]),
	},
})
export default class ConfirmationForm extends Vue {
	public ID_1 = "1";
	public ID_2 = "2";
	public ID_3 = "3";
	public ID_4 = "4";
	public ID_5 = "5";

	public isButtonDisable = true;

	public readonly ACTION = { SIGN_IN: "signIn", SIGN_UP: "signUp" };

	// ************************************************************
	// Define mapGetters
	public confirmation: {
		isConfirm: boolean;
		user: { createdId: number };
		partner: { createdId: number };
		relation: { isRelation: false };
		attempts: number;
		isExpired: boolean;
		actionType: string;
	};

	public increaseAttempts: { count: number };
	public phoneNumber: {
		phone: string;
		actionType: string;
	};

	// ************************************************************
	// Define mapActions
	public checkConfirmationCodeAction!: (payload: {
		code: string;
		phone: string;
		action: string;
	}) => Promise<void>;

	public increaseAttemptsAction!: (payload: {
		phone: string;
		action: string;
	}) => Promise<void>;

	public checkAuthAction!: () => void;

	public loginGenerateConfirmationCodeAction!: (payload: {
		phone: string;
	}) => Promise<void>;

	public registrationAction!: (payload: { phone: string }) => Promise<void>;

	/**
	 * Hook mounted
	 */
	public mounted() {
		// Сбрасываем значения
		this.confirmation.isExpired = false;
		this.increaseAttempts.count = 0;

		// Установим фокус на первую ячейку
		const digit = this.$refs.d1 as HTMLInputElement;
		digit.focus();

		// Если кто-то попытался перейти на страницу confirmation, вернём его на исходную страницу.
		if (this.phoneNumber.phone === "") {
			this.$router.back();
		}
	}

	/**
	 * Computed
	 * Возвращает количество попыток
	 */
	public get attemptsCount() {
		return this.increaseAttempts.count;
	}

	/**
	 * Computed
	 * Время проверочного кода.
	 * true - Истёк
	 * false - Не истёк
	 */
	public get isExpired() {
		if (this.confirmation?.isExpired !== undefined) {
			return this.confirmation?.isExpired;
		} else {
			return false;
		}
	}

	/**
	 * Обработка нажатия лавиатуры
	 * @param event
	 */
	public onDigit(event: Event) {
		const id = (event.target as HTMLInputElement).id;
		const value = (event.target as HTMLInputElement).value;
		let digit;

		const key = (event as KeyboardEvent).key;

		switch (id) {
			case this.ID_1:
				if (this.isValid(this.$refs.d1 as HTMLInputElement, value)) {
					digit = this.$refs.d2 as HTMLInputElement;
					digit.focus();
				}
				break;
			case this.ID_2:
				if (this.isValid(this.$refs.d2 as HTMLInputElement, value)) {
					digit = this.$refs.d3 as HTMLInputElement;
					digit.focus();
				}

				if (key === "Backspace") {
					digit = this.$refs.d1 as HTMLInputElement;
					digit.focus();
				}

				break;
			case this.ID_3:
				if (this.isValid(this.$refs.d3 as HTMLInputElement, value)) {
					digit = this.$refs.d4 as HTMLInputElement;
					digit.focus();
				}

				if (key === "Backspace") {
					digit = this.$refs.d2 as HTMLInputElement;
					digit.focus();
				}

				break;
			case this.ID_4:
				if (this.isValid(this.$refs.d4 as HTMLInputElement, value)) {
					digit = this.$refs.d5 as HTMLInputElement;
					digit.focus();
				}

				if (key === "Backspace") {
					digit = this.$refs.d3 as HTMLInputElement;
					digit.focus();
				}

				break;
			case this.ID_5:
				this.isValid(this.$refs.d5 as HTMLInputElement, value);

				if (key === "Backspace") {
					digit = this.$refs.d4 as HTMLInputElement;
					digit.focus();
				}
		}

		const d1 = (this.$refs.d1 as HTMLInputElement).value;
		const d2 = (this.$refs.d2 as HTMLInputElement).value;
		const d3 = (this.$refs.d3 as HTMLInputElement).value;
		const d4 = (this.$refs.d4 as HTMLInputElement).value;
		const d5 = (this.$refs.d5 as HTMLInputElement).value;

		// Если хоть одна ячейка не заполнена, это значит isButtonDisable = TRUE
		this.isButtonDisable = !(
			d1 !== "" &&
			d2 !== "" &&
			d3 !== "" &&
			d4 !== "" &&
			d5 !== ""
		);
	}

	/**
	 * Проверяем валидность ввода
	 * @param ref
	 * @param value
	 */
	public isValid(ref: HTMLInputElement, value: string) {
		const regExp = /^\d+$/;

		if (value.length > 1) {
			ref.value = "";
			return false;
		}
		if (!regExp.test(value)) {
			ref.value = "";
			return false;
		}

		return true;
	}

	/**
	 * Отправляем код подтверждения
	 */
	public async onClickCheckCode() {
		if (this.isButtonDisable) {
			return;
		}

		const d1 = (this.$refs.d1 as HTMLInputElement).value;
		const d2 = (this.$refs.d2 as HTMLInputElement).value;
		const d3 = (this.$refs.d3 as HTMLInputElement).value;
		const d4 = (this.$refs.d4 as HTMLInputElement).value;
		const d5 = (this.$refs.d5 as HTMLInputElement).value;

		const code = d1 + d2 + d3 + d4 + d5;

		// Номер телефона, который указали на странице регистрации
		let phone = this.phoneNumber?.phone;
		let action = this.phoneNumber?.actionType;

		/**
		 * Проверка введенного кода
		 */
		await this.checkConfirmationCodeAction({
			code: code,
			phone: phone.toString(),
			action: action.toString(),
		});

		const isConfirm = this.confirmation.isConfirm;
		const attempts = this.confirmation.attempts;
		const userId = this.confirmation.user.createdId;
		const partnerId = this.confirmation.partner.createdId;
		const isRelation = this.confirmation.relation.isRelation;
		const actionType = this.confirmation.actionType;
		console.log("confirmation", this.confirmation);

		// Если введённый код совпал.
		if (isConfirm && attempts < 3) {
			// Если выполнились успешно действия по созданию нового пользователя
			if (userId !== 0 && partnerId !== 0 && isRelation) {
				// 1. Проверяем аутентификацию пользователя
				await this.checkAuthAction();

				// 2. Переход на страницу инстансов
				this.$router.push({
					path: "/",
					query: {
						page: 1,
					},
				});
			} else if (actionType === this.ACTION.SIGN_IN) {
				// 1. Проверяем аутентификацию пользователя
				await this.checkAuthAction();

				// 2. Переход на страницу инстансов
				this.$router.push({
					path: "/",
					query: {
						page: 1,
					},
				});
			}
		} else {
			// Если введённый код не совпал.
			// 1. +1 к attempts
			await this.increaseAttemptsAction({
				phone: phone.toString(),
				action: action.toString(),
			});

			// 2. Очищаем все ячейки с цифрами
			(this.$refs.d1 as HTMLInputElement).value = "";
			(this.$refs.d2 as HTMLInputElement).value = "";
			(this.$refs.d3 as HTMLInputElement).value = "";
			(this.$refs.d4 as HTMLInputElement).value = "";
			(this.$refs.d5 as HTMLInputElement).value = "";

			// 3. Делаем кнопку не активной
			this.isButtonDisable = true;

			// 4. Установим фокус на первую ячейку
			const digit = this.$refs.d1 as HTMLInputElement;
			digit.focus();
		}
	}

	/**
	 * Повторно отправить проверочный код
	 */
	public async resendConfirmCode(): Promise<void> {
		// Номер телефона, который указали на странице регистрации
		const phone = this.phoneNumber?.phone;
		const actionType = this.phoneNumber?.actionType;

		if (actionType === this.ACTION.SIGN_IN) {
			// Для авторизация
			// 1. Генерируем проверочный код
			await this.loginGenerateConfirmationCodeAction({
				phone: phone,
			});
		} else if (actionType === this.ACTION.SIGN_UP) {
			// Для регистрация
			await this.registrationAction({ phone: phone });
		}

		this.confirmation.isExpired = false;
	}

	/**
	 * Форматирование номера телефона
	 * Возвращает строку такого вида: +7 (914) 234-34-50
	 * @param num
	 */
	public formatPhoneNumber(num: string | null) {
		if (num !== null) {
			return num.replace(
				/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/g,
				`+$1 ($2) $3-$4-$5`
			);
		} else {
			return "";
		}
	}
}
</script>

<style scoped lang="scss">
.cf {
	padding: 24px;
	background: rgb(255, 255, 255);
	border-radius: 12px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);

	&__elm {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	&__elm-label {
		color: rgb(49, 49, 50);
		padding-top: 16px;
	}

	&__elm-code {
		display: flex;
		justify-content: center;
		padding: 16px 0 16px;
	}

	&__elm-code-input {
		display: flex;
		justify-content: center;
		align-items: center;

		width: 46px;
		height: 46px;
		background: rgb(244, 246, 250);
		border-radius: 12px;
		margin-right: 8px;
	}

	&__elm-code-input-num {
		text-align: center;
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		width: 35px;
		height: 35px;
		-moz-appearance: textfield;
		font-size: 28px;
	}

	&__elm-code-input-num:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
	}

	&__elm-code-input-num::-webkit-outer-spin-button,
	&__elm-code-input-num::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	&__elm-btn {
		min-width: 265px;
	}

	&__elm-send-code {
		color: rgb(119, 121, 124);
		padding: 16px;
		cursor: pointer;
	}

	&__elm-error {
		padding-top: 16px;
		color: rgb(232, 57, 65);
	}

	@media screen and (max-width: 768px) {
		padding: 12px;

		&__elm {
			display: block;
		}

		&__elm-label {
			text-align: center;
		}

		&__elm-send-code {
			text-align: center;
		}
	}
}
</style>
